/**
 * Preline 5's `plugins/*` builds are side-effect bundles: they attach a class
 * to `window` and do not provide a default ESM export. Importing them this way
 * keeps apexcharts, datatables.net and dropzone out of the bundle.
 *
 * Plugins scan the DOM once. In an SPA that DOM is replaced on every
 * navigation, so we call `autoInit()` again after each route change.
 */
import 'preline/plugins/collapse'
import 'preline/plugins/dropdown'
import 'preline/plugins/tabs'
import 'preline/plugins/toggle-password'
import 'preline/plugins/tooltip'

type AutoInitPlugin = { autoInit?: () => void }

function plugins(): AutoInitPlugin[] {
  const w = window as unknown as {
    HSCollapse?: AutoInitPlugin
    HSDropdown?: AutoInitPlugin
    HSTabs?: AutoInitPlugin
    HSTogglePassword?: AutoInitPlugin
    HSTooltip?: AutoInitPlugin
  }

  return [w.HSCollapse, w.HSDropdown, w.HSTabs, w.HSTogglePassword, w.HSTooltip].filter(
    (plugin): plugin is AutoInitPlugin => Boolean(plugin),
  )
}

export function initPreline(): void {
  for (const plugin of plugins()) {
    try {
      plugin.autoInit?.()
    } catch (error) {
      console.warn('[preline] autoInit failed', error)
    }
  }
}

export async function refreshPreline(): Promise<void> {
  await new Promise((resolve) => requestAnimationFrame(resolve))
  initPreline()
}
